import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { getStoreDetail } from 'features/store/ducks/get-store-by-id';
import { InlineNotification } from 'common/components/inline-notification';
import { cx } from 'linaria';
import { critical, important, common, container } from './styles';

export const DATA_QA_STORE_NOTIFICATIONS = 'store-notifications';

type Props = {
  className?: string;
};

export const StoreNotifications: FC<Props> = ({ className }) => {
  const {
    commonNotificationTitle,
    commonNotificationDescription,
    importantNotificationTitle,
    importantNotificationDescription,
    criticalNotificationTitle,
    criticalNotificationDescription,
  } = useSelector(getStoreDetail) || {};

  const notifications = [
    { cssClass: critical, title: criticalNotificationTitle, description: criticalNotificationDescription },
    {
      cssClass: important,
      title: importantNotificationTitle,
      description: importantNotificationDescription,
    },
    { cssClass: common, title: commonNotificationTitle, description: commonNotificationDescription },
  ].filter((n) => !!n.title && !!n.description);

  return notifications.length ? (
    <div className={cx(container, className)} data-qa={DATA_QA_STORE_NOTIFICATIONS}>
      {notifications.map(({ cssClass, title = '', description = '' }) => (
        <InlineNotification message={description} title={title} className={cssClass} key={title} />
      ))}
    </div>
  ) : null;
};
